import EditIcon from '@mui/icons-material/Edit';
import {
    Box,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Tooltip,
    Typography,
} from '@mui/material';

type Column = {
    key: string;
    label: string;
    render?: (row: any) => React.ReactNode;
    width?: number | string;
    align?: 'left' | 'center' | 'right';
};

type Props = {
    data: any[];
    columns: Column[];
    onEdit?: (row: any) => void;
    rowActions?: (row: any) => React.ReactNode;
    getRowSx?: (row: any) => Record<string, any>;
    emptyMessage?: string;
};

export default function BolTable({
    data,
    columns,
    onEdit,
    rowActions,
    getRowSx,
    emptyMessage = 'No records found.',
}: Props) {
    const showActionsColumn = !!onEdit || !!rowActions;

    return (
        <Table
            stickyHeader
            size="small"
            sx={{
                '& .MuiTableCell-stickyHeader': {
                    // backgroundColor: 'background.paper',
                    zIndex: 2,
                    fontWeight: 700,
                },
                // '& .MuiTableCell-root': { py: 0.5 }
            }}
        >
            <TableHead>
                <TableRow>
                    {columns.map((col) => (
                        <TableCell
                            key={col.key}
                            align={col.align || 'left'}
                        // sx={{
                        //     width: col.width,
                        //     whiteSpace: 'nowrap',
                        //     fontWeight: 700,
                        // }}
                        >
                            {col.label}
                        </TableCell>
                    ))}

                    {showActionsColumn && (
                        <TableCell
                            align="center"
                            sx={{
                                width: 90,
                                whiteSpace: 'nowrap',
                                fontWeight: 700,
                            }}
                        >
                            Actions
                        </TableCell>
                    )}
                </TableRow>
            </TableHead>

            <TableBody>
                {data.length === 0 ? (
                    <TableRow>
                        <TableCell
                            colSpan={columns.length + (showActionsColumn ? 1 : 0)}
                            align="center"
                            sx={{ py: 4 }}
                        >
                            <Typography variant="body2" color="text.secondary">
                                {emptyMessage}
                            </Typography>
                        </TableCell>
                    </TableRow>
                ) : (
                    data.map((row) => {
                        const defaultCancelledRowSx = row?.cancel
                            ? {
                                backgroundColor: '#e9e9e9',
                                '& td': {
                                    color: '#8c8c8c',
                                },
                            }
                            : {};

                        return (
                            <TableRow
                                key={row.bol_no}
                                hover
                                sx={{
                                    ...defaultCancelledRowSx,
                                    ...(getRowSx ? getRowSx(row) : {}),
                                }}
                            >
                                {columns.map((col) => (
                                    <TableCell
                                        key={col.key}
                                        align={col.align || 'left'}
                                        sx={{
                                            verticalAlign: 'middle',
                                            width: col.width,
                                        }}
                                    >
                                        {col.render ? col.render(row) : row[col.key]}
                                    </TableCell>
                                ))}

                                {showActionsColumn && (
                                    <TableCell align="center">
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                gap: 0.5,
                                                flexWrap: 'wrap',
                                            }}
                                        >
                                            {onEdit && (
                                                <Tooltip title="Edit">
                                                    <IconButton size="small" onClick={() => onEdit(row)}>
                                                        <EditIcon fontSize="small" />
                                                    </IconButton>
                                                </Tooltip>
                                            )}

                                            {rowActions?.(row)}
                                        </Box>
                                    </TableCell>
                                )}
                            </TableRow>
                        );
                    })
                )}
            </TableBody>
        </Table>
    );
}